import { render } from "./GuestIndex.vue?vue&type=template&id=06c8b051"
import script from "./GuestIndex.vue?vue&type=script&lang=js"
export * from "./GuestIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__